import { useMemo } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';

export const usePlayerContainer = () => {
  const player = usePlayer();

  return useMemo(() => {
    try {
      return player.getContainer();
    } catch {
      return document.getElementById(player.getRawConfig().node)!;
    }
  }, [player]);
};
